// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + {"1261": "__federation_expose_core","4679": "__federation_expose_LinkedRecordBase",}[chunkId] + "." + {"1261": "a20b0035dc010871","4679": "a20b0035dc010871",}[chunkId] + ".css"
}